import React from 'react';
import {
  List as RaList,
  DateField,
  TextField,
  EmailField,
  EditButton,
  FunctionField,
  useGetIdentity,
  BooleanField,
} from 'react-admin';

import CustomizableDatagrid from '../../../utils/libs/CustomizableDatagridLib';
import { Filter } from './Filter';
import { ShowIdButton } from '../../../components/ShowIdButton';
import { CUSTOM_STORAGE } from '../../../constants/list-column-custom-storage';
import { usePageTitle } from '../../../components/usePageTitle';
import { withPermissions } from '../../../components/hoc/WithPermissions';
import { USER_ROLE } from '../../../constants/statuses';

const DEFAULT_COLUMNS = [
  'id',
  'email',
  'fullName',
  'role',
  'type',
  'createdAt',
  'geoGroup',
];

const List = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();

  if (identityLoading) {
    return null;
  }
  return (
    <RaList {...props} filters={<Filter />} bulkActionButtons={false}>
      <CustomizableDatagrid
        storage={CUSTOM_STORAGE}
        defaultColumns={DEFAULT_COLUMNS}
      >
        <ShowIdButton source="id" />
        <EmailField source="email" />
        <TextField source="fullName" />
        <FunctionField
          label="Roles"
          render={(record) => record.roles?.join(', ')}
        />
        <TextField label="Geo group" source="geoGroup.name" />
        <TextField source="type" />
        <TextField source="telegram" />
        <TextField source="pstid" label="PST ID" />
        <TextField
          source="provider_transaction_sum"
          label="Provider transaction sum"
        />
        <TextField source="cards_count" label="Cards count" />
        <TextField source="money_requests_count" label="Money requests count" />
        <TextField source="transaction_count" label="Transaction count" />
        <BooleanField source="is_deleted" label="Is deleted" />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <EditButton />
      </CustomizableDatagrid>
    </RaList>
  );
};
export default withPermissions(List, null, [USER_ROLE.SUPER_ADMIN]);
